export default __webpack_public_path__ + "static/media/left.0af95c47.svg";